import CovidImg from "../../assets/images/webp/UpdatesPage/covidUpdate.webp";

const CovidUpdate = () => (
  <div className="article-update">
    <div className="posted">
      <div className="text">Posted on:</div>
      <div className="date">May 6, 2020</div>
    </div>
    <div className="title">COVID-19 UPDATE</div>
    <div className="image-section">
      <img className="image" src={CovidImg} alt="covid update img" />
    </div>
    <div className="highlight-text">
      Have you heard the news? We’re down to essentials-only for a couple of weeks. Because we both know how essential
      you workouts are, we’re going VIRTUAL!
    </div>
    <div className="text">
      As of now, this will be in effect until April 6th. We are excited to already have measures in place to work with
      our clients through this period.
    </div>
    <div className="text">– Sessions can be held via FaceTime or Skype.</div>
    <div className="text">– Family sessions are HIGHLY encouraged.</div>
    <div className="text">– Starting Monday, March 23rd at midnight – Ending (hopefully) Monday, April 6th.</div>
    <div className="text">
      It is because of our awesome staff and clientele that we will rise to the occasion and continue to move through
      this together! We appreciate you!
    </div>

    <div className="line-break extra-space-up" />
  </div>
);

export default CovidUpdate;
